import React from 'react'
import {Link} from 'react-router-dom'

function WorkNextPD21(props) {
    const { link, noMore } = props;
    return(

            <section id="projectNext" className="section">
                <div className="container-fluid-small">
                    <div className="row">
                        <div className="col-12 project-nav anim-bot">
                            
                            { noMore === 'done' ? 
                            <Link to={`works-ID2021-1`}>
                                インテリアデザイン演習【3回生作品】
                            </Link>
                            :
                            <Link to={`works-PD2021-${link}`}>
                                NEXT PROJECT
                            </Link>
                            }
                            
                        </div>
                    </div>
                </div>
            </section>

    )

}

export default WorkNextPD21